import { IPromise } from 'angular';
import * as _ from 'underscore';

import { ActionContext } from '../helpers/ActionContext';
import { ResultHelper } from '../helpers/ResultHelper';
import { Module } from '../Module';
import {
  DeleteMySavedPasswordsAndCredentialsRequest,
} from '../ServerApi/requests/DeleteMySavedPasswordsAndCredentialsRequest';
import { ConfirmActionDialog, IConfirmActionDialogInstance } from './ConfirmActionDialog';
import { ServerService } from './ServerService';
import { ToasterService, ToastType } from './ToasterService';

export class DeleteMyCredentialsAction {

  public static $inject = ['$translate', '$q', 'ConfirmActionDialog', 'ServerService'];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private $q: ng.IQService,
    private ConfirmActionDialog: ConfirmActionDialog,
    private serverService: ServerService
  ) { }

  public executeFromEvent($event: JQueryEventObject): IPromise<any> {
    const actionContext = ActionContext.fromEvent($event);

    const confirmActionDialogInstance = this.ConfirmActionDialog.open({
      scope: actionContext.scope,
      title : this.$translate.instant('clearSavedCredentials'),
      bodyText : this.$translate.instant('clearUserSavedCredentialsConfirmMessage'),
      actionName : this.$translate.instant('clearSavedCredentialsConfirmButton'),
      isDeleteAction: true,
      action : (confirmActionDialogInstance: IConfirmActionDialogInstance) => {
        return this.serverService.sendRequest(new DeleteMySavedPasswordsAndCredentialsRequest())
          .then(ResultHelper.rejectResultOnError(this.$q))
          .then(_.identity, () => confirmActionDialogInstance.showErrorMessage(this.$translate.instant('clearSavedCredentialsError')));
      }
    });

    confirmActionDialogInstance.result.then((result: any) => {
      ToasterService.instance.pop({ type: ToastType.Info, text: this.$translate.instant('clearSavedCredentialsSuccess')});
    });

    return confirmActionDialogInstance.result;
  }

}

Module.instance().service('DeleteMyCredentialsAction', DeleteMyCredentialsAction);
